<template>
  <div>
    <header>
      关键字：
      <el-input
        v-model="search.userName"
        placeholder="搜索姓名"
        style="width: 300px"
      ></el-input>
      <!-- 单位：
      <el-select
        v-model="search.authorityUnitId"
        placeholder="请选择"
      >
        <el-option
          v-for="c in companyList"
          :key="c.value"
          :label="c.label"
          :value="c.value"
        > </el-option>
      </el-select> -->
      部门：
      <el-select
        v-model="search.departmentId"
        placeholder="请选择"
      >
        <el-option
          v-for="d in departList"
          :key="d.value"
          :label="d.label"
          :value="d.value"
        > </el-option>
      </el-select>
      角色：
      <el-select
        v-model="search.roleId"
        placeholder="请选择"
      >
        <el-option
          v-for="r in roleList"
          :key="r.value"
          :label="r.label"
          :value="r.value"
        > </el-option>
      </el-select>
      状态：
      <el-select
        v-model="search.status"
        placeholder="请选择"
      >
        <el-option
          v-for="s in statusList"
          :key="s.value"
          :label="s.label"
          :value="s.value"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="handlerSearch"
      >查询</el-button>
      <el-button
        type="primary"
        @click="open"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        width="180"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="unitName"
        label="单位"
        width="180"
      >
      </el-table-column> -->
      <el-table-column
        prop="departmentName"
        label="部门"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="roleName"
        label="角色"
        align="center"
      >
      </el-table-column>

      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.status == 1 ?'有效':'无效'}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleClick(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="editId?'编辑':'新增'"
      :visible.sync="addDialogVisible"
      width="1300px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :model="trainForm"
        label-width="160px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="用户名:"
              prop="userAccount"
            >
              <el-input v-model="trainForm.userAccount"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <!-- <el-input v-model="trainForm.userPwd"></el-input> -->
              <el-input
                placeholder="请输入8-16位包含大小写字母数字符号的密码"
                v-model="trainForm.userPwd"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="真实姓名:">
              <el-input v-model="trainForm.realName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="性别:">
              <el-radio
                v-model="trainForm.userSex"
                label="男"
              >男</el-radio>
              <el-radio
                v-model="trainForm.userSex"
                label="女"
              >女</el-radio>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="电话:"
              prop="telephone"
            >
              <el-input v-model="trainForm.telephone"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="身份证号码:">
              <el-input v-model="trainForm.idCard"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item
              label="1单位:"
              prop="authorityUnitId"
            >
              <el-select
                v-model="trainForm.authorityUnitId"
                placeholder="请选择"
              >
                <el-option
                  v-for="r in companyList2"
                  :key="r.value"
                  :label="r.label"
                  :value="r.value"
                > </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <el-form-item
              label="部门:"
              prop="departmentId"
            >
              <el-select
                v-model="trainForm.departmentId"
                placeholder="请选择"
              >
                <el-option
                  v-for="d in departList2"
                  :key="d.value"
                  :label="d.label"
                  :value="d.value"
                > </el-option>
              </el-select>
              <!-- <el-input v-model="trainForm.departmentId"></el-input> -->
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="角色:"
              prop="roleId"
            >
              <el-select
                v-model="trainForm.roleId"
                placeholder="请选择"
              >
                <el-option
                  v-for="r in roleList2"
                  :key="r.value"
                  :label="r.label"
                  :value="r.value"
                > </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="邮箱:"
              prop="email"
            >
              <el-input v-model="trainForm.email"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="电子签名:">
              <!-- <el-col :span="6">
                <el-input v-model="trainForm.signatureImage"></el-input>
              </el-col> -->
              <el-col :span="4">
                <el-upload
                  style="display:inline-block;"
                  action=""
                  :auto-upload="true"
                  :http-request="uploadImg"
                  :show-file-list='true'
                  :file-list="fileList"
                  :on-change="handleChange"
                >
                  <el-button
                    type="primary"
                    style="margin-left: 20px"
                  >选择</el-button>
                </el-upload>
                <!-- <el-upload class="upload-demo" :action="uploadImgUrl" :on-preview="handlePreview"
                  :on-remove="handleRemove" multiple="false" :on-exceed="handleExceed" :file-list="fileList"
                  :on-change="handleChange" :before-upload="beforeAvatarUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload> -->
                <!-- <el-input v-model="trainForm.name"></el-input> -->
              </el-col>
              <el-col>
                <div>上传照片要求：尺寸建议300*180px、文件大小不超过100KB、JPG或PNG图片格式</div>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="trainForm.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="trainForm.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button
            :disabled="isDisable"
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>

        </el-form-item>

      </el-form>

    </el-dialog>

    <authorization
      :isShow="authorizationShow"
      @isShow='closeAuthor'
    />

  </div>
</template>

<script>
import {
  provinceAndCityData
} from 'element-china-area-data'
import authorization from '@/components/authorization.vue'
import { validatorPhone, validatorEmail, validatorPassword } from "@/util/validateRules.js";
import { DebounceBy } from '@/util/util.js'
import {
  Api_user,
  Api_unit,
  Api_depart,
  Api_role,
  Api_Base,
  Api_Company
} from '@/api/api'
import { getStore } from '@/util/store'
export default {
  components: {
    authorization
  },
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      authorizationShow: false,
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      addDialogVisible: false,
      search: {
        userName: '',
        // authorityUnitId: -1,
        departmentId: -1,
        roleId: -1,
        status: -1
      },
      statusList: [{
        label: '全部',
        value: -1
      },
      {
        label: '有效',
        value: 1
      },
      {
        label: '无效',
        value: 2
      },
      ],
      roleList: [{
        label: '全部',
        value: -1
      },],
      roleList2: [{
        label: '请选择',
        value: ''
      },],
      departList: [{
        label: '全部',
        value: -1
      },],
      departList2: [{
        label: '请选择',
        value: ''
      },],
      companyList: [{
        label: '全部',
        value: -1
      },],
      // companyList2: [{
      //   label: '请选择',
      //   value: ''
      // },],
      trainForm: {
        userAccount: '',
        userPwd: '',
        realName: '',
        // authorityUnitId: '',
        userSex: 1,
        telephone: '',
        idCard: '',
        departmentId: '',
        roleId: '',
        signatureImage: '',
        status: 1,
        email: ''
      },
      originalPassword: '', // 存储原始密码
      rules: {
        userAccount: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur",
        }],
        userPwd: [
          {
            // 动态设置是否必填
            required: function (rule, value, callback) {
              if (this.editId && value === this.originalPassword) {
                callback(); // 编辑时密码未变，不校验
              } else {
                callback(value ? undefined : new Error('请输入密码'));
              }
            }.bind(this),
            trigger: "blur",
          },
          {
            // 动态设置是否校验密码格式
            validator: function (rule, value, callback) {
              if (this.editId && value == this.originalPassword) {
                callback(); // 编辑时密码未变，不校验
              } else {
                validatorPassword(rule, value, callback);
              }
            }.bind(this),
            trigger: "change",
          },
        ],
        telephone: [{
          required: true,
          message: "请输入电话",
          trigger: "blur",
        }],
        departmentId: [{
          required: true,
          message: "请选择部门",
          trigger: "blur",
        }],
        // authorityUnitId: [{
        //   required: true,
        //   message: "请选择单位",
        //   trigger: "blur",
        // }],
        roleId: [{
          required: true,
          message: "请选择角色",
          trigger: "blur",
        }],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur",
        }],
        email: [{
          required: false,
          message: "请输入邮箱",
          trigger: "blur",
        }, { trigger: "blur", validator: validatorEmail }],
      },
      companyId: getStore({ name: 'companyId' }),
      projectId: getStore({ name: 'projectId' }),
      fileList: [],
      uploadImgUrl: '',
      isDisable: false, // 按钮是否可以点击
      editId: 0,
    };
  },
  created() {
    this.getUnitList()
    this.getDepartList()
    this.getRoleList()
    this.handlerSearch()
    console.log(Api_Base.upLoadFile)
    this.uploadImgUrl = `${Api_Base.upLoadFile}/1`;
  },
  methods: {

    uploadImg(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then(res => {
        if (res.data.data[0].fileUrl) {
          this.trainForm.signatureImage = res.data.data[0].fileUrl
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }

      })
    },


    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = []
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    beforeAvatarUpload(file) {
      const typeArr = ["image/png", "image/jpg", "image/jepg"];
      const isJPG = typeArr.indexOf(file.type) !== -1;
      const isLt3M = file.size / 1024 < 100;
      if (!isJPG) {
        this.$message.error("只能上传图片!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 100KB!");
      }
      return isJPG && isLt3M;
    },
    getUnitList() {
      this.companyList = [{
        label: '全部',
        value: -1
      }]
      this.companyList2 = [{
        label: '请选择',
        value: ''
      }]
      let params = {
        projectId: this.projectId,
        unitName: '',
        unitType: 0, // 全部
        status: -1, // 全部
        pageSize: 10,
        pageIndex: 1,
      }
      Api_unit.getUnitList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          result.data.tList.map(item => {
            this.companyList.push({
              label: item.unitName,
              value: item.authorityCompanyId // TODO 金金来了确认接口和查询时候的id
            })
            // this.companyList2.push({
            //   label: item.unitName,
            //   value: item.id // TODO 金金来了确认接口和查询时候的id
            // })
          })
        }
      })
    },
    getDepartList() {
      this.departList = [{
        label: '全部',
        value: -1
      }]
      this.departList2 = [{
        label: '请选择',
        value: ''
      }]
      let params = {
        status: -1,
        projectId: this.projectId,
        departmentName: '',
        companyId: this.companyId,
        pageSize: 9999,
        pageIndex: 1
      }
      Api_depart.getDepartList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          result.data.tList.map(item => {
            this.departList.push({
              label: item.departmentName,
              value: item.id // TODO 金金来了确认接口和查询时候的id
            })
            this.departList2.push({
              label: item.departmentName,
              value: item.id // TODO 金金来了确认接口和查询时候的id
            })
          })
        }
      })
    },
    getRoleList() {
      this.roleList = [{
        label: '全部',
        value: -1
      }]
      this.roleList2 = [{
        label: '请选择',
        value: ''
      }]
      let params = {
        projectId: this.projectId,
        status: -1,
        roleName: '',
        companyId: this.companyId,
        pageSize: 9999,
        pageIndex: 1
      }
      Api_role.getRoleList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          result.data.tList.map(item => {
            this.roleList.push({
              label: item.roleName,
              value: item.id // TODO 金金来了确认接口和查询时候的id
            })
            this.roleList2.push({
              label: item.roleName,
              value: item.id // TODO 金金来了确认接口和查询时候的id
            })
          })
        }
      })
    },
    open(val) {
      this.isDisable = false
      this.fileList = []
      this.trainForm = {
        userAccount: '',
        userPwd: '',
        realName: '',
        userSex: '男',
        telephone: '',
        idCard: '',
        departmentId: '',
        roleId: '',
        signatureImage: '',
        status: 1
      }
      this.addDialogVisible = true
    },
    closeAuthor(val) {
      this.authorizationShow = val
    },
    handleClick(val) {
      this.editId = val.id
      Api_user.detail(val.id).then(res => {
        this.trainForm = res.data.data
        this.originalPassword = res.data.data.userPwd; // 存储原始密码
        this.addDialogVisible = true
        if (res.data.data.signatureImage) {
          this.fileList.push({ name: res.data.data.signatureImage })
        }
      })
    },
    // handleChange(value) {
    //   console.log(value)
    // },
    handleDel(val) {
      this.$confirm('是否删除此部门?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_Company.delUser(val.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handlerSearch() {
      let params = {
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        companyId: this.companyId,
        project: this.projectId
      }
      params = Object.assign({}, params, this.search)
      Api_Company.getUserList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.tableData = result.data.tList
          this.totalCount = result.data.totalCount
        }
      })
    },
    // handleChange(file, fileList) {
    //   if (!this.multiple) {
    //     this.fileList = [];
    //     this.fileList.push(file);
    //   }
    //   this.file = file;
    //   this.fileName = file.name;
    //   this.$emit("handleChange", file);
    // },
    addUser() {
      let params = {
        projectId: this.projectId,
        companyId: this.companyId,
      }
      if (this.trainForm.id) {
        this.isDisable = false
        params = Object.assign({}, params, this.trainForm)
        Api_Company.editUser(params).then(res => {
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
            this.addDialogVisible = false
            this.$message({
              type: "success",
              message: "保存成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: result.errors,
            });
          }
        })
      } else {
        params = Object.assign({}, params, this.trainForm)
        Api_Company.addUser(params).then(res => {
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
            this.addDialogVisible = false
            this.$message({
              type: "success",
              message: "保存成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: result.errors,
            });
          }
          this.isDisable = false
        }).catch(err => {
          this.isDisable = false
        })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisable = true
          this.addUser()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.addDialogVisible = false
      this.trainForm = {}
      this.fileList = []
      this.isDisable = false
      this.editId = 0
    },
    handleClose() {
      this.resetForm()
    },
  },
};
</script>